/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { NodeCompat } from '../../../compat/NodeCompat';
import { Constants } from '../../../core/Constants';
import { AuthorizationCodeOAuthFlow } from '../../../core/models/common/AuthorizationCodeOAuthFlow';
import { ClientCredentialsOAuthFlow } from '../../../core/models/common/ClientCredentialsOAuthFlow';
import { Components } from '../../../core/models/common/Components';
import { IDefinition } from '../../../core/models/common/IDefinition';
import { IExample } from '../../../core/models/common/IExample';
import { ImplicitOAuthFlow } from '../../../core/models/common/ImplicitOAuthFlow';
import { OAuthFlows } from '../../../core/models/common/OAuthFlows';
import { PasswordOAuthFlow } from '../../../core/models/common/PasswordOAuthFlow';
import { SecurityScheme } from '../../../core/models/common/SecurityScheme';
import { Server } from '../../../core/models/common/Server';
import { ServerVariable } from '../../../core/models/common/ServerVariable';
import { OasHeader } from '../../models/OasHeader';
import { Oas30Callback } from '../models/Oas30Callback';
import { Oas30CallbackDefinition } from '../models/Oas30CallbackDefinition';
import { Oas30CallbackPathItem } from '../models/Oas30CallbackPathItem';
import { Oas30Discriminator } from '../models/Oas30Discriminator';
import { Oas30Encoding } from '../models/Oas30Encoding';
import { Oas30Example } from '../models/Oas30Example';
import { Oas30ExampleDefinition } from '../models/Oas30ExampleDefinition';
import { Oas30HeaderDefinition } from '../models/Oas30HeaderDefinition';
import { Oas30Link } from '../models/Oas30Link';
import { Oas30LinkDefinition } from '../models/Oas30LinkDefinition';
import { Oas30LinkParameterExpression } from '../models/Oas30LinkParameterExpression';
import { Oas30LinkRequestBodyExpression } from '../models/Oas30LinkRequestBodyExpression';
import { Oas30LinkServer } from '../models/Oas30LinkServer';
import { Oas30MediaType } from '../models/Oas30MediaType';
import { Oas30RequestBody } from '../models/Oas30RequestBody';
import { Oas30RequestBodyDefinition } from '../models/Oas30RequestBodyDefinition';
import { OasNodePathVisitor } from '../../visitors/OasNodePathVisitor';
import { IOas30Visitor } from './IOas30Visitor';
import { NodePath } from '../../../core/models/NodePath';
import { Oas30Schema } from '../models/Oas30Schema';
import { Node } from '../../../core/models/Node';

/**
 * Constructor.
 * @class
 * @extends OasNodePathVisitor
 * @author eric.wittmann@gmail.com
 */
export class Oas30NodePathVisitor extends OasNodePathVisitor implements IOas30Visitor {
    public constructor() {
        super();
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.NodePathVisitor#visitSchemaDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitSchemaDefinition(node : IDefinition) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_SCHEMAS, false);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.NodePathVisitor#visitParameterDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitParameterDefinition(node : IDefinition) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_PARAMETERS, false);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.NodePathVisitor#visitSecurityScheme(io.apicurio.datamodels.core.models.common.SecurityScheme)
     * @param {SecurityScheme} node
     */
    public visitSecurityScheme(node : SecurityScheme) {
        this.path.prependSegment(node.getSchemeName(), true);
        this.path.prependSegment(Constants.PROP_SECURITY_SCHEMES, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.OasNodePathVisitor#visitResponseDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitResponseDefinition(node : IDefinition) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_RESPONSES, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitComponents(io.apicurio.datamodels.core.models.common.Components)
     * @param {Components} node
     */
    public visitComponents(node : Components) {
        this.path.prependSegment(Constants.PROP_COMPONENTS, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitCallbackPathItem(io.apicurio.datamodels.openapi.v3.models.Oas30CallbackPathItem)
     * @param {Oas30CallbackPathItem} node
     */
    public visitCallbackPathItem(node : Oas30CallbackPathItem) {
        this.path.prependSegment(node.getPath(), true);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitCallback(io.apicurio.datamodels.openapi.v3.models.Oas30Callback)
     * @param {Oas30Callback} node
     */
    public visitCallback(node : Oas30Callback) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_CALLBACKS, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLinkServer(io.apicurio.datamodels.openapi.v3.models.Oas30LinkServer)
     * @param {Oas30LinkServer} node
     */
    public visitLinkServer(node : Oas30LinkServer) {
        this.path.prependSegment(Constants.PROP_SERVER, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitCallbackDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30CallbackDefinition)
     * @param {Oas30CallbackDefinition} node
     */
    public visitCallbackDefinition(node : Oas30CallbackDefinition) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_CALLBACKS, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLink(io.apicurio.datamodels.openapi.v3.models.Oas30Link)
     * @param {Oas30Link} node
     */
    public visitLink(node : Oas30Link) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_LINKS, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLinkRequestBodyExpression(io.apicurio.datamodels.openapi.v3.models.Oas30LinkRequestBodyExpression)
     * @param {Oas30LinkRequestBodyExpression} node
     */
    public visitLinkRequestBodyExpression(node : Oas30LinkRequestBodyExpression) {
        this.path.prependSegment(Constants.PROP_REQUEST_BODY, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLinkParameterExpression(io.apicurio.datamodels.openapi.v3.models.Oas30LinkParameterExpression)
     * @param {Oas30LinkParameterExpression} node
     */
    public visitLinkParameterExpression(node : Oas30LinkParameterExpression) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_PARAMETERS, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLinkDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30LinkDefinition)
     * @param {Oas30LinkDefinition} node
     */
    public visitLinkDefinition(node : Oas30LinkDefinition) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_LINKS, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitAuthorizationCodeOAuthFlow(io.apicurio.datamodels.core.models.common.AuthorizationCodeOAuthFlow)
     * @param {AuthorizationCodeOAuthFlow} node
     */
    public visitAuthorizationCodeOAuthFlow(node : AuthorizationCodeOAuthFlow) {
        this.path.prependSegment(Constants.PROP_AUTHORIZATION_CODE, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitClientCredentialsOAuthFlow(io.apicurio.datamodels.core.models.common.ClientCredentialsOAuthFlow)
     * @param {ClientCredentialsOAuthFlow} node
     */
    public visitClientCredentialsOAuthFlow(node : ClientCredentialsOAuthFlow) {
        this.path.prependSegment(Constants.PROP_CLIENT_CREDENTIALS, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitPasswordOAuthFlow(io.apicurio.datamodels.core.models.common.PasswordOAuthFlow)
     * @param {PasswordOAuthFlow} node
     */
    public visitPasswordOAuthFlow(node : PasswordOAuthFlow) {
        this.path.prependSegment(Constants.PROP_PASSWORD, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitImplicitOAuthFlow(io.apicurio.datamodels.core.models.common.ImplicitOAuthFlow)
     * @param {ImplicitOAuthFlow} node
     */
    public visitImplicitOAuthFlow(node : ImplicitOAuthFlow) {
        this.path.prependSegment(Constants.PROP_IMPLICIT, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitOAuthFlows(io.apicurio.datamodels.core.models.common.OAuthFlows)
     * @param {OAuthFlows} node
     */
    public visitOAuthFlows(node : OAuthFlows) {
        this.path.prependSegment(Constants.PROP_FLOWS, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitExample(io.apicurio.datamodels.core.models.common.IExample)
     * @param {*} node
     */
    public visitExample(node : IExample) {
        let example30 : Oas30Example = <Oas30Example><any>node;
        this.path.prependSegment(example30.getName(), true);
        this.path.prependSegment(Constants.PROP_EXAMPLES, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitEncoding(io.apicurio.datamodels.openapi.v3.models.Oas30Encoding)
     * @param {Oas30Encoding} node
     */
    public visitEncoding(node : Oas30Encoding) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_ENCODING, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitMediaType(io.apicurio.datamodels.openapi.v3.models.Oas30MediaType)
     * @param {Oas30MediaType} node
     */
    public visitMediaType(node : Oas30MediaType) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_CONTENT, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.OasNodePathVisitor#visitHeader(io.apicurio.datamodels.openapi.models.OasHeader)
     * @param {OasHeader} node
     */
    public visitHeader(node : OasHeader) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_HEADERS, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitHeaderDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30HeaderDefinition)
     * @param {Oas30HeaderDefinition} node
     */
    public visitHeaderDefinition(node : Oas30HeaderDefinition) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_HEADERS, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitRequestBody(io.apicurio.datamodels.openapi.v3.models.Oas30RequestBody)
     * @param {Oas30RequestBody} node
     */
    public visitRequestBody(node : Oas30RequestBody) {
        this.path.prependSegment(Constants.PROP_REQUEST_BODY, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitRequestBodyDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30RequestBodyDefinition)
     * @param {Oas30RequestBodyDefinition} node
     */
    public visitRequestBodyDefinition(node : Oas30RequestBodyDefinition) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_REQUEST_BODIES, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitExampleDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30ExampleDefinition)
     * @param {Oas30ExampleDefinition} node
     */
    public visitExampleDefinition(node : Oas30ExampleDefinition) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_EXAMPLES, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitDiscriminator(io.apicurio.datamodels.openapi.v3.models.Oas30Discriminator)
     * @param {Oas30Discriminator} node
     */
    public visitDiscriminator(node : Oas30Discriminator) {
        this.path.prependSegment(Constants.PROP_DISCRIMINATOR, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitNotSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30NotSchema)
     * @param {Oas30Schema.Oas30NotSchema} node
     */
    public visitNotSchema(node : Oas30Schema.Oas30NotSchema) {
        this.path.prependSegment(Constants.PROP_NOT, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitOneOfSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30OneOfSchema)
     * @param {Oas30Schema.Oas30OneOfSchema} node
     */
    public visitOneOfSchema(node : Oas30Schema.Oas30OneOfSchema) {
        let idx : number = NodeCompat.indexOf(node, node.parent(), Constants.PROP_ONE_OF);
        if(idx !== -1) {
            this.path.prependSegment(/* valueOf */new String(idx).toString(), true);
            this.path.prependSegment(Constants.PROP_ONE_OF, false);
        }
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitAnyOfSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30AnyOfSchema)
     * @param {Oas30Schema.Oas30AnyOfSchema} node
     */
    public visitAnyOfSchema(node : Oas30Schema.Oas30AnyOfSchema) {
        let idx : number = NodeCompat.indexOf(node, node.parent(), Constants.PROP_ANY_OF);
        if(idx !== -1) {
            this.path.prependSegment(/* valueOf */new String(idx).toString(), true);
            this.path.prependSegment(Constants.PROP_ANY_OF, false);
        }
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitServer(io.apicurio.datamodels.core.models.common.Server)
     * @param {Server} node
     */
    public visitServer(node : Server) {
        let idx : number = NodeCompat.indexOf(node, node.parent(), Constants.PROP_SERVERS);
        if(idx !== -1) {
            this.path.prependSegment(/* valueOf */new String(idx).toString(), true);
            this.path.prependSegment(Constants.PROP_SERVERS, false);
        }
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitServerVariable(io.apicurio.datamodels.core.models.common.ServerVariable)
     * @param {ServerVariable} node
     */
    public visitServerVariable(node : ServerVariable) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_VARIABLES, false);
    }
}
Oas30NodePathVisitor["__class"] = "io.apicurio.datamodels.openapi.v3.visitors.Oas30NodePathVisitor";
Oas30NodePathVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




